import "./App.css";
import KnowYourBenefitsForm from "./components/KnowYourBenefitsForm";

function App() {
  return (
    <KnowYourBenefitsForm />
  );
}

export default App;
